module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(typeof _vm.user !== 'undefined') ? _c('span', [(!_vm.present) ? _c('span', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" " + _vm._s(_vm.user.name) + "\n      ")]) : _vm._e()]) : _c('span', [_c('pulse-loader', {
    attrs: {
      "color": "#cccccc",
      "size": "8px"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b7cb77a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Entities/User.vue
// module id = 708
// module chunks = 1